import React, { useState, useEffect } from 'react'
import { withStyles, Grid, Typography } from '@material-ui/core'
import chatRepository from './ChatRepository'
import { Snackbar } from 'elentari'
import { ComentarioForm, ComentariosList } from '../Comentarios'
import Fetching from '../../components/Fetching'

const styles = theme => ({
  root: {
    padding: theme.spacing(6)
  },
  empty: {
    marginTop: '256px'
  }
})

const ChatChard = ({ classes, cannotUpdate, tarefa, ...props }) => {
  const [chat, setChat] = useState(null)
  const [mensagem, setMensagem] = useState('')

  const fetchData = async itemId => {
    let response

    if (tarefa) {
      response = await chatRepository.getByTarefaId(itemId, {
        include: [{ relation: 'comentarios' }]
      })
    } else {
      response = await chatRepository.getBySolicitacaoId(itemId, {
        include: [{ relation: 'comentarios' }]
      })
    }

    if (response.ok) {
      setChat(response.data)
    }
  }

  useEffect(() => {
    fetchData(props.match.params.id)
    const interval = setInterval(
      () => fetchData(props.match.params.id),
      1000 * 30
    )
    return () => clearInterval(interval)
  }, [props.match.params.id])

  const onSubmit = result => {
    if (result.ok) {
      fetchData(props.match.params.id)
    } else {
      setMensagem('Ops! algo deu errado')
    }
  }

  return chat ? (
    <Grid container direction="row" justifyContent="center" alignItems="center">
      <Grid item sm={12} xs={12}>
        <Typography variant="h6" gutterBottom>
          Comentários
        </Typography>
      </Grid>
      <Grid item sm={12} xs={12}>
        <ComentariosList comentarios={chat.comentarios} />
      </Grid>
      <Grid item sm={12} xs={12}>
        <div hidden={cannotUpdate}>
          <Typography variant="body2">Deixe um novo comentário:</Typography>
          <ComentarioForm {...props} onSubmit={onSubmit} chatId={chat.id} />
        </div>
      </Grid>
      <Snackbar message={mensagem} onClose={() => setMensagem('')} />
    </Grid>
  ) : (
    <Fetching />
  )
}

export default withStyles(styles)(ChatChard)
